export const NODE_TYPE = 'nodeType';
export const NODE_TYPE_REF = 'nodeTypeRef';
